import { slice as billingAddressSlice } from '@client/myAccount/accountDetails/redux/billingAddress/redux';
import { slice as detailsSlice } from '@client/myAccount/accountDetails/redux/details/redux';
import { combineSlices } from '@reduxjs/toolkit';

export const accountDetailsReducer = combineSlices(
  billingAddressSlice,
  detailsSlice,
);
